export const normalizeUnitPrice = (
  unit_price: number | string | null | undefined,
): number | null => {
  if (unit_price === '' || unit_price == null || unit_price === 'null') {
    return null;
  }

  const parsed = Number(unit_price);
  return Number.isNaN(parsed) ? null : parsed;
};
